// Zentrale Kontaktdaten und Servicezeiten (Ortszeit Marokko).
export const PHONE_DISPLAY = "+212 70 80 76 900";
export const PHONE_TEL = "+212708076900";
export const WHATSAPP_URL = "https://wa.me/212708076900";
export const SERVICE_TZ = "Africa/Casablanca";
export const OPEN_FROM = 8;   // 08:00
export const OPEN_TO = 18;    // 18:00

// true, wenn gerade Servicezeit ist (Mo-Fr, 08:00-18:00 Ortszeit Marokko)
export function isServiceOpen(now = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-GB", { timeZone: SERVICE_TZ, weekday: "short", hour: "numeric", minute: "numeric", hour12: false }).formatToParts(now);
    const get = (t) => parts.find((p) => p.type === t)?.value;
    const day = get("weekday");
    const hour = parseInt(get("hour"), 10) % 24;
    return ["Mon", "Tue", "Wed", "Thu", "Fri"].includes(day) && hour >= OPEN_FROM && hour < OPEN_TO;
  } catch (e) { return false; }
}
